import { Box } from "@familyzone/component-library";
import React from "react";
import { ImportScheduleFile } from "./ImportScheduleFile";
import { ScheduleCSVObject } from "./ScheduleCSVObject";

interface Props {
  csvObjects: Set<ScheduleCSVObject>;
  updateCsvObjectsCallback: (csvObjects: Set<ScheduleCSVObject>) => void;
  deleteCsvObjectCallback: (csvObject: ScheduleCSVObject) => void;
  onParseError?: (csvObject: ScheduleCSVObject) => void;
}

export function ImportScheduleFileList(props: Props): JSX.Element {
  const handleDeleteFile = (csvObjectToDelete: ScheduleCSVObject) => {
    props.deleteCsvObjectCallback(csvObjectToDelete);
  };

  const handleReaderCallback = (_updatedCsvObject: ScheduleCSVObject) => {
    props.updateCsvObjectsCallback(props.csvObjects);
  };

  return (
    <Box id="list" mt={10}>
      {Array.from(props.csvObjects).map((csvObject) => (
        <ImportScheduleFile
          key={`${csvObject.getFile().name}-${csvObject.getFile().size}-${csvObject.getFile().lastModified}`}
          csvObject={csvObject}
          readerCallback={handleReaderCallback}
          deleteFile={handleDeleteFile}
          onParseError={props.onParseError}
        />
      ))}
    </Box>
  );
}
